<template>
    <ul class="Menu">
        <slot />
    </ul>
</template>

<script>
export default {
};
</script>
<style lang="scss" scoped>
.Menu {
    list-style: none;
    padding: 20px;
    margin: 0;
    min-width: 330px;
    .menuItem:last-child {
        margin-bottom: 0;
    }
}
</style>
